export default __webpack_public_path__ + "static/media/soumyadeep.ee4538ad.jpg";